import { useParams } from 'react-router';
/**
 * @returns the packageId from the current route (url) - handles document packages, building packages, and layout optimizations
 */
export const usePackageId = () => {
    const { packageId, buildingPackageId, layoutId } = useParams();
    // Return whichever ID is present
    const id = packageId || buildingPackageId || layoutId;
    if (id == null) {
        throw new Error(`usePackageId called with invalid ID - expected packageId, buildingPackageId, or layoutId but all are undefined`);
    }
    return id;
};
